export const addDash = ( phoneNumber, setPhoneNumberHandler ) => {
    phoneNumber.length === 3 ? setPhoneNumberHandler( prevNum => prevNum + '-' ) : null;
    phoneNumber.length === 7 ? setPhoneNumberHandler( prevNum => prevNum + '-' ) : null;
};

//format number 
export const formatNumber = phoneNumber => {
    if(phoneNumber) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }
};

export const validPhoneNUmber = (phoneNumber, setPhoneNumberHandler ) => {

    const key = window.event ? window.event.data : undefined;

    if(window.event && window.event.inputType && window.event.inputType  === 'deleteContentBackward') {
        setPhoneNumberHandler( prevNum => prevNum.slice(0, -1));
    } else if(key && key.match(/[0-9]/g) !== null &&  phoneNumber.length < 12) {
        addDash(phoneNumber, setPhoneNumberHandler);
        setPhoneNumberHandler(prevNum => prevNum + key);
    } else if(key && key === '-' && (phoneNumber.length === 3 || phoneNumber.length === 7)) {
        setPhoneNumberHandler(prevNum => prevNum + key);        
    }

};


    